import styled from "styled-components";
import DeleteButtonFullText from "../buttons/DeleteButtonFullText";
import React, {useState} from "react";
import YesNoModal from "../modal/YesNoModal";
import {useDispatch, useSelector} from "react-redux";
import {deleteOneUser} from "../user/usersAction";
import TokenService from "../../services/token.service";
import {displayAlert} from "../../utils/utils";

const DeleteAccountSection = () => {
    const [openDeleteModal, setOpenDeleteModal] = useState(false)
    const [isErrors, setIsErrors] = useState(false)
    const [isSent, setIsSent] = useState(false)
    const {id} = useSelector(state => state.currentUser)
    const dispatch = useDispatch()

    const deleteRequest = async (id) => {
        try{
            await dispatch(deleteOneUser(id))
             setIsSent(true)
           setTimeout(() => {
               TokenService.logout()
               window.location.reload()
           }, 1000)

        } catch {
            setIsErrors(true)
        }
    }

    const displayModal = () => {
        if (openDeleteModal) {
            return <YesNoModal
                id={id}
                name={"votre compte"}
                handleClickYesAction={deleteRequest}
                setOpenModal={setOpenDeleteModal}
            />
        }
    }
    return (
        <Container>
            {displayAlert(isSent, isErrors)}
            <p> Vous vous apprêtez à supprimer votre compte Enjoy Your Business.</p>
            <h2> Ce que vous devez savoir : </h2>
            <ul>
                <li> Si vous êtes pilote d'un projet, vous serez anonymisé</li>
                <li> Si vous êtes sponsor d'un axe, il n'y aura plus de sponsor sur cet axe</li>
                <li> Vous serez supprimé de tous les projets dont vous êtes membres</li>
            </ul>
            <DeleteButtonFullText setModalOpen={setOpenDeleteModal}/>
            {displayModal()}
        </Container>

    )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;

  .delete-btn-full {
    margin-top: 1em;
   align-self: center;
  }
`


export default DeleteAccountSection